import { Component, inject, Input, OnInit } from '@angular/core';
import { GlobalPageHeaderComponent } from '../../global-page-header/global-page-header.component';
import {
  IonButton,
  IonContent,
  IonFooter,
  IonItem,
  IonLabel,
  IonList,
  IonModal,
  ModalController,
} from '@ionic/angular/standalone';
import { TranslatePipe } from '@ngx-translate/core';
import { NgCircleProgressModule } from 'ng-circle-progress';
import { convertMinutesToTime } from '../../../services/ecosystems/helper/convertSecondsToTime';
import {
  getHorlogeTotalTime,
  transformWeltico2WeekModelToBuffer,
  transformWelticoWeekBufferToModel,
  Weltico2HorlogeModel,
} from '../../../services/ecosystems/helper/horloge';
import Moment from 'moment';
import moment from 'moment';
import { AppComponent } from '../../../app.component';

export function getColorDescriptor(projecteurType: any, colorCode: any) {
  if (projecteurType === 3) {
    for (let i = 0; i < weltico2CouleurType.length; i++) {
      for (let j = 0; j < weltico2CouleurType[i].colors.length; j++) {
        for (let k = 0; k < weltico2CouleurType[i].colors[j].length; k++) {
          if (weltico2CouleurType[i].colors[j][k].code === colorCode) {
            return weltico2CouleurType[i].colors[j][k];
          }
        }
      }
    }
  } else if (projecteurType === 4) {
    for (let i = 0; i < weltico2BlancType.length; i++) {
      for (let j = 0; j < weltico2BlancType[i].colors.length; j++) {
        for (let k = 0; k < weltico2BlancType[i].colors[j].length; k++) {
          if (weltico2BlancType[i].colors[j][k].code === colorCode) {
            return weltico2BlancType[i].colors[j][k];
          }
        }
      }
    }
  }

  return null;
}

export const weltico2CouleurType: any = [
  {
    title: 'P00039.weltico.v2.colors.title',
    colors: [
      [
        {
          code: 22,
          title: 'P00039.weltico.v2.colors.list22',
          color: '#FFFFFF',
          overrideColor: true,
          image: null,
          type: 'round',
          forceTextBlackOnSelect: true,
        },
        {
          code: 21,
          title: 'P00039.weltico.v2.colors.list21',
          color: 'rgba(255,255,255,0.75)',
          overrideColor: true,
          image: null,
          type: 'round',
          forceTextBlackOnSelect: true,
        },
        {
          code: 20,
          title: 'P00039.weltico.v2.colors.list20',
          color: 'rgba(255,255,255,0.5)',
          overrideColor: true,
          image: null,
          type: 'round',
          forceTextBlackOnSelect: true,
        },
        {
          code: 19,
          title: 'P00039.weltico.v2.colors.list19',
          color: 'rgba(255,255,255,0.25)',
          overrideColor: true,
          image: null,
          type: 'round',
          forceTextBlackOnSelect: true,
        },
      ],
      [
        {
          code: 11,
          title: 'P00039.weltico.v2.colors.list11',
          color: '#ceceb7',
          image: null,
          type: 'round',
        },
        {
          code: 8,
          title: 'P00039.weltico.v2.colors.list8',
          color: '#ff0000',
          image: null,
          type: 'round',
        },
        {
          code: 7,
          title: 'P00039.weltico.v2.colors.list7',
          color: '#ff008b',
          image: null,
          type: 'round',
        },
        {
          code: 6,
          title: 'P00039.weltico.v2.colors.list6',
          color: '#ff00f7',
          image: null,
          type: 'round',
        },
      ],
      [
        {
          code: 5,
          title: 'P00039.weltico.v2.colors.list5',
          color: '#b300d6',
          image: null,
          type: 'round',
        },
        {
          code: 2,
          title: 'P00039.weltico.v2.colors.list2',
          color: '#0303ff',
          image: null,
          type: 'round',
        },
        {
          code: 4,
          title: 'P00039.weltico.v2.colors.list4',
          color: '#00f9f6',
          image: null,
          type: 'round',
        },
        {
          code: 3,
          title: 'P00039.weltico.v2.colors.list3',
          color: '#00f9a1',
          image: null,
          type: 'round',
        },
      ],
      [
        {
          code: 10,
          title: 'P00039.weltico.v2.colors.list10',
          color: '#00d200',
          image: null,
          type: 'round',
        },
        {
          code: 9,
          title: 'P00039.weltico.v2.colors.list9',
          color: '#ff4c00',
          image: null,
          type: 'round',
        },
        {},
        {},
      ],
    ],
  },
  {
    title: 'P00039.weltico.v2.sequences.title',
    colors: [
      [
        {
          code: 12,
          title: 'P00039.weltico.v2.colors.list12',
          color: null,
          image:
            '/assets/ecosystem/images/products/P00039/welticov2/welticov2Mode12.png',
          selectedImage:
            '/assets/ecosystem/images/products/P00039/welticov2/welticov2ModeSelected12.png',
          type: 'rectangle',
        },
        {
          code: 13,
          title: 'P00039.weltico.v2.colors.list13',
          color: null,
          image:
            '/assets/ecosystem/images/products/P00039/welticov2/welticov2Mode13.png',
          selectedImage:
            '/assets/ecosystem/images/products/P00039/welticov2/welticov2ModeSelected13.png',
          type: 'rectangle',
        },
        {
          code: 14,
          title: 'P00039.weltico.v2.colors.list14',
          color: null,
          image:
            '/assets/ecosystem/images/products/P00039/welticov2/welticov2Mode14.png',
          selectedImage:
            '/assets/ecosystem/images/products/P00039/welticov2/welticov2ModeSelected14.png',
          type: 'rectangle',
        },
      ],
      [
        {
          code: 17,
          title: 'P00039.weltico.v2.colors.list17',
          color: null,
          image:
            '/assets/ecosystem/images/products/P00039/welticov2/welticov2Mode17.png',
          selectedImage:
            '/assets/ecosystem/images/products/P00039/welticov2/welticov2ModeSelected17.png',
          type: 'rectangle',
        },
        {
          code: 16,
          title: 'P00039.weltico.v2.colors.list16',
          color: null,
          image:
            '/assets/ecosystem/images/products/P00039/welticov2/welticov2Mode16.png',
          selectedImage:
            '/assets/ecosystem/images/products/P00039/welticov2/welticov2ModeSelected16.png',
          type: 'rectangle',
        },
        {
          code: 18,
          title: 'P00039.weltico.v2.colors.list18',
          color: null,
          image:
            '/assets/ecosystem/images/products/P00039/welticov2/welticov2Mode18.png',
          selectedImage:
            '/assets/ecosystem/images/products/P00039/welticov2/welticov2ModeSelected18.png',
          type: 'round',
        },
      ],
      [
        {
          code: 25,
          title: 'P00039.weltico.v2.colors.list25',
          color: null,
          image:
            '/assets/ecosystem/images/products/P00039/welticov2/welticov2Mode25.png',
          selectedImage:
            '/assets/ecosystem/images/products/P00039/welticov2/welticov2ModeSelected25.png',
          type: 'round',
        },
        {
          code: 24,
          title: 'P00039.weltico.v2.colors.list24',
          color: null,
          image:
            '/assets/ecosystem/images/products/P00039/welticov2/welticov2Mode24.png',
          selectedImage:
            '/assets/ecosystem/images/products/P00039/welticov2/welticov2ModeSelected24.png',
          type: 'round',
        },
        {
          code: 23,
          title: 'P00039.weltico.v2.colors.list23',
          color: null,
          image:
            '/assets/ecosystem/images/products/P00039/welticov2/welticov2Mode23.png',
          selectedImage:
            '/assets/ecosystem/images/products/P00039/welticov2/welticov2ModeSelected23.png',
          type: 'round',
        },
      ],
    ],
  },
];

export const weltico2BlancType: any = [
  {
    title: 'P00039.weltico.v2.white.title',
    colors: [
      [
        {
          code: 22,
          title: 'P00039.weltico.v2.colors.list22',
          color: '#FFFFFF',
          overrideColor: true,
          image: null,
          type: 'round',
          forceTextBlackOnSelect: true,
        },
        {
          code: 21,
          title: 'P00039.weltico.v2.colors.list21',
          color: 'rgba(255,255,255,0.75)',
          overrideColor: true,
          image: null,
          type: 'round',
          forceTextBlackOnSelect: true,
        },
        {
          code: 20,
          title: 'P00039.weltico.v2.colors.list20',
          color: 'rgba(255,255,255,0.5)',
          overrideColor: true,
          image: null,
          type: 'round',
          forceTextBlackOnSelect: true,
        },
        {
          code: 19,
          title: 'P00039.weltico.v2.colors.list19',
          color: 'rgba(255,255,255,0.25)',
          overrideColor: true,
          image: null,
          type: 'round',
          forceTextBlackOnSelect: true,
        },
      ],
    ],
  },
];

@Component({
  selector: 'app-function-parameters-settings-weltico2-clock-screen',
  templateUrl:
    './function-parameters-settings-weltico2-clock-screen.component.html',
  styleUrls: [
    './function-parameters-settings-weltico2-clock-screen.component.scss',
  ],
  imports: [
    GlobalPageHeaderComponent,
    IonButton,
    IonContent,
    TranslatePipe,
    IonFooter,
    NgCircleProgressModule,
    IonItem,
    IonLabel,
    IonList,
    IonModal,
  ],
})
export class FunctionParametersSettingsWeltico2ClockScreenComponent
  implements OnInit
{
  private modalController = inject(ModalController);

  @Input() value: string = '';
  public valueResult: string = '';
  @Input() welticoColors: any = weltico2CouleurType;
  @Input() colorType: number = 3;

  public weekDay: number = 0;
  public horlogeModels: any = [];
  public selectModel: Weltico2HorlogeModel | null = null;
  public selectModelStep: number = 0;

  isModalOpen = false;

  constructor() {}

  public list: any = [];
  public minuteInterval: number = 60;

  getWelticoColor(color: number): any {
    let selectedColor = null;
    this.welticoColors.map((d: any) => {
      d.colors.map((colors: any, index: any) => {
        colors.map((c: any) => {
          if (c.code === color) {
            selectedColor = c;
          }
        });
      });
    });
    return selectedColor;
  }

  ngOnInit() {
    for (let i = 0; i < 60 * 24; i = i + this.minuteInterval) {
      this.list.push({ label: convertMinutesToTime(i), ref: i * 60 });
    }

    this.valueResult = this.value;

    if (this.colorType === 3) {
      this.welticoColors = weltico2CouleurType;
    } else {
      this.welticoColors = weltico2BlancType;
    }

    this.horlogeModels = transformWelticoWeekBufferToModel(this.valueResult);
  }

  onCloseSelectTimeIntervalChoice(
    ref: number,
    startDate: number,
    endDate: number,
    color: number,
  ) {
    this.isModalOpen = false;

    if (ref == -1) {
      this.horlogeModels[this.weekDay].push({
        ref: this.horlogeModels[this.weekDay].length + 1,
        start: startDate,
        end: endDate,
        color,
      });
    } else {
      for (let i = 0; i < this.horlogeModels[this.weekDay].length; i++) {
        if (this.horlogeModels[this.weekDay][i].ref == ref) {
          this.horlogeModels[this.weekDay][i].start = startDate;
          this.horlogeModels[this.weekDay][i].end = endDate;
          this.horlogeModels[this.weekDay][i].color = color;
        }
      }
    }

    const buf = transformWeltico2WeekModelToBuffer(this.horlogeModels);
    this.valueResult = buf;
    this.horlogeModels = transformWelticoWeekBufferToModel(buf);
  }

  secondeToHourMinute(time: number) {
    let h = Math.floor(time / (60 * 60));
    let m = Math.floor((time - h * 3600) / 60);

    return h.toString().padStart(2, '0') + ':' + m.toString().padStart(2, '0');
  }

  tempsTotal() {
    const time = getHorlogeTotalTime(this.horlogeModels[this.weekDay]);
    return this.secondeToHourMinute(time);
  }

  setWeekDays(wekDay: number) {
    this.weekDay = wekDay;
  }

  onCloseSelectTimeIntervalRemove(ref: number) {
    for (let i = 0; i < this.horlogeModels[this.weekDay].length; i++) {
      if (this.horlogeModels[this.weekDay][i].ref == ref) {
        this.horlogeModels[this.weekDay].splice(i, 1);

        const buf = transformWeltico2WeekModelToBuffer(this.horlogeModels);
        this.valueResult = buf;
        this.horlogeModels = transformWelticoWeekBufferToModel(buf);
        break;
      }
    }

    this.isModalOpen = false;
  }

  transformNumberToDegree(num: number) {
    return (num * 360) / (60 * 60 * 24);
  }

  selectColor(value: number) {
    this.selectModel!.color = value;
  }

  nextStep() {
    this.selectModelStep = this.selectModelStep + 1;
  }

  goToStep(step: number) {
    this.selectModelStep = step;
  }

  selectStart(value: number) {
    this.selectModel!.start = value;
  }

  selectEnd(value: number) {
    this.selectModel!.end = value;
  }

  openModal(selectModel: Weltico2HorlogeModel | null = null) {
    if (selectModel == null) {
      let hourStr = Moment().format('HH');
      this.selectModelStep = 0;
      this.selectModel = {
        ref: -1,
        start: parseInt(hourStr) * 3600,
        end: ((parseInt(hourStr) + 1) % 24) * 3600,
        color: 0,
      };
    } else {
      this.selectModel = JSON.parse(JSON.stringify(selectModel));
      this.selectModelStep = 3;
    }

    console.log(this.selectModel);
    this.isModalOpen = true;
  }

  deleteModel() {
    this.onCloseSelectTimeIntervalRemove(this.selectModel!.ref);
  }

  saveModel() {
    this.onCloseSelectTimeIntervalChoice(
      this.selectModel!.ref,
      this.selectModel!.start,
      this.selectModel!.end,
      this.selectModel!.color,
    );
  }

  closeModal() {
    this.isModalOpen = false;
    this.selectModel = null;
  }

  async dismissModal(): Promise<void> {
    await this.modalController.dismiss({ value: this.valueResult });
  }

  getStartDate() {
    return moment.utc(this.selectModel!.start! * 1000).format('HH:mm');
  }
  getEndDate() {
    return moment.utc(this.selectModel!.end! * 1000).format('HH:mm');
  }

  protected readonly AppComponent = AppComponent;
}
